<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.3334 9.99935C18.3334 14.5993 14.6001 18.3327 10.0001 18.3327C5.40008 18.3327 1.66675 14.5993 1.66675 9.99935C1.66675 5.39935 5.40008 1.66602 10.0001 1.66602C14.6001 1.66602 18.3334 5.39935 18.3334 9.99935Z"
      :stroke="props.color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M13.0917 12.6495L10.5083 11.1078C10.0583 10.8411 9.69165 10.1995 9.69165 9.67448V6.25781"
      :stroke="props.color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<script setup>

import { defineProps } from 'vue';

const props = defineProps({
  color: {
    type: String,
    default: 'rgb(var(--locumate-primary-color))',
  },
});

</script>